import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { ChangeVehicleLink } from 'site-modules/shared/components/appraisal/trade-in-appraiser-links/trade-in-appraiser-links';
import { AppraisalEntities, AppraisalModel, buildAllStylesAppraisalFilteredPath } from 'client/data/models/appraisal';
import { TrackingConstant } from 'client/tracking/constant';
import { PopoverItem } from 'site-modules/shared/components/popover-item/popover-item';
import { getAppraisalValues } from 'site-modules/shared/utils/appraisal/common-utils';

import './mmy-title.scss';

/**
 * Renders Make Model Year H1 title.
 * @param {object} vehicle
 * @param {number} year
 * @param {boolean} isMobile
 * @returns {ReactElement}
 */
export class MMYTitleUI extends Component {
  static propTypes = {
    vehicle: VehicleEntities.StyleWithoutSubmodels,
    year: PropTypes.number.isRequired,
    isAppExtensionPage: PropTypes.bool,
    appraisalStyles: AppraisalEntities.Styles,
  };

  static defaultProps = {
    vehicle: {},
    isAppExtensionPage: false,
    appraisalStyles: [],
  };

  getTmvRangeCopy = ({ title, hasEstimatedPrices, minAppraisalValue, maxAppraisalValue }) => {
    const hasEstimatedPriceCopy = hasEstimatedPrices
      ? `range from ${minAppraisalValue} - ${maxAppraisalValue}`
      : 'vary significantly by zip code, mileage, and condition';
    return `${title} trade-in prices ${hasEstimatedPriceCopy}. Get a more accurate value for your car with the Edmunds appraisal tool.`;
  };

  render() {
    const { vehicle, year, isAppExtensionPage, appraisalStyles } = this.props;
    const make = get(vehicle, 'makeName', '');
    const model = get(vehicle, 'modelName', '');
    const title = `${year} ${make} ${model}`.trim();

    const { minAppraisalValue, maxAppraisalValue } = getAppraisalValues({ appraisalStyles });
    const hasEstimatedPrices = minAppraisalValue && maxAppraisalValue;
    const tmvRangeCopy = this.getTmvRangeCopy({ title, hasEstimatedPrices, minAppraisalValue, maxAppraisalValue });

    const openTrackingParams = {
      creative_id: 'edm-entry-appraisal-page',
      value: 'More Info',
      subaction_name: TrackingConstant.VIEW_MORE_INFO,
    };

    return (
      <div className="mmy-title mb-1_5">
        <h1 className="heading-3 text-white text-shadow-contrast">
          <span>
            {title} Value
            <PopoverItem
              className="header-info-btn"
              iconClassName="header-info-icon size-14 text-white text-shadow-contrast"
              innerClassName="text-gray-darker p-0_75"
              placement="bottom"
              screenReaderTooltipLabel={title}
              openTrackingParams={openTrackingParams}
            >
              <Fragment>
                <div aria-hidden className="fw-bold mb-0_25">
                  {year} {make} {model}
                </div>
                {tmvRangeCopy}
              </Fragment>
            </PopoverItem>{' '}
            -{' '}
          </span>
          <span className="fw-normal">Find Out What Your Car&apos;s Worth</span>
        </h1>
        <ChangeVehicleLink
          className="mt-0_5 text-shadow-contrast"
          isAppExtensionPage={isAppExtensionPage}
          color="white"
        />
      </div>
    );
  }
}

export const stateToPropsConfig = {
  appraisalStyles: bindToPath(
    ({ vehicle: { makeSlug, modelSlug, year } }) =>
      buildAllStylesAppraisalFilteredPath({ make: makeSlug, model: modelSlug, year }),
    AppraisalModel
  ),
};

export const MMYTitle = connectToModel(MMYTitleUI, stateToPropsConfig);
